import { render, staticRenderFns } from "./detailPage.vue?vue&type=template&id=cd2cc836&scoped=true&"
import script from "./detailPage.vue?vue&type=script&lang=js&"
export * from "./detailPage.vue?vue&type=script&lang=js&"
import style0 from "./detailPage.vue?vue&type=style&index=0&id=cd2cc836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2cc836",
  null
  
)

export default component.exports